import React, { useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { v4 as uuid } from 'uuid';
import { CLIENT_ID, LOGIN_PATH, DISCOVERY_DOCUMENT_LINK } from '../helpers/constants';
import GoogleIcon from './icons/GoogleIcon';

const LoginButton = ({ className }) => {
  const [authURI, setAuthURI] = useState(null);

  useEffect(() => {
    async function createAuthURI() {
      let gauthUrl = '';
      let authEndPoint = localStorage.getItem('authorization_endpoint');
      if (!authEndPoint) {
        const responseJSON = await (await fetch(DISCOVERY_DOCUMENT_LINK)).json();
        authEndPoint = responseJSON['authorization_endpoint'];
        localStorage.setItem('authorization_endpoint', responseJSON['authorization_endpoint']);
        localStorage.setItem('token_endpoint', responseJSON['token_endpoint']);
        localStorage.setItem('jwks_uri', responseJSON['jwks_uri']);
      }

      // Use fixed redirect URI without query parameters
      const redirectUri = LOGIN_PATH;

      let uid = localStorage.getItem('session-uid');
      if (!uid) {
        uid = uuid();
        localStorage.setItem('session-uid', uid);
      }

      gauthUrl += authEndPoint;
      gauthUrl =
        gauthUrl +
        '?client_id=' +
        CLIENT_ID +
        '&response_type=code&scope=openid email&state=' +
        encodeURIComponent(uid) +
        '&redirect_uri=' +
        encodeURIComponent(redirectUri);
      setAuthURI(gauthUrl);
    }
    createAuthURI();
  }, []);

  const button = (
    <Button
      className={`${className || ''} d-inline-flex align-items-center justify-content-center`}
      id="my-signin2"
      variant="info"
      disabled={!authURI}
    >
      {!authURI ? <Spinner size="sm" animation="border" /> : <GoogleIcon />}
      <span className="ml-2">Sign In With Google</span>
    </Button>
  );

  if (!authURI) return button;

  return <a href={authURI}>{button}</a>;
};

export default LoginButton;
